
import { useToast } from "@/hooks/use-toast";

interface VATRegistrationUploadProps {
  vatRegistration: File | null;
  onUpload: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const VATRegistrationUpload = ({ 
  vatRegistration, 
  onUpload 
}: VATRegistrationUploadProps) => {
  return (
    <div className="space-y-2">
      <h3 className="font-semibold text-sm">VAT Registration (Optional):</h3>
      <input
        type="file"
        accept=".pdf"
        onChange={onUpload}
        className="text-sm file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-medium file:bg-primary file:text-primary-foreground hover:file:bg-primary/90 cursor-pointer w-full"
      />
      <p className="text-xs text-muted-foreground">
        Upload VAT registration document if available (PDF only, max 10MB)
      </p>
      {vatRegistration && (
        <p className="text-sm text-primary">
          Selected file: {vatRegistration.name}
        </p>
      )}
    </div>
  );
};
